export default __webpack_public_path__ + "static/DockerCompact-13c26b982beb0337f158b983abd09de3.svg";